var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29277 0C1.92194 0 0 1.92194 0 4.29277C0 6.66359 1.92194 8.58554 4.29277 8.58554C6.66359 8.58554 8.58553 6.66359 8.58553 4.29277C8.58553 1.92194 6.66359 0 4.29277 0ZM2.34151 4.29277C2.34151 3.21511 3.21511 2.34151 4.29277 2.34151C5.37042 2.34151 6.24402 3.21511 6.24402 4.29277C6.24402 5.37042 5.37042 6.24403 4.29277 6.24403C3.21511 6.24403 2.34151 5.37042 2.34151 4.29277Z",
    fill: "#0EC99E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.537C0 9.89038 0.52417 9.36621 1.17075 9.36621H7.41478C8.06136 9.36621 8.58553 9.89038 8.58553 10.537V30.83C8.58553 31.4766 8.06136 32.0008 7.41478 32.0008H1.17075C0.52417 32.0008 0 31.4766 0 30.83V10.537ZM2.34151 11.7077V29.6593H6.24402V11.7077H2.34151Z",
    fill: "#0EC99E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9258 10.537C10.9258 9.89038 11.45 9.36621 12.0965 9.36621H18.3406C18.9871 9.36621 19.5113 9.89038 19.5113 10.537V11.2145L20.1908 10.9233C21.3589 10.4226 22.6082 10.1087 23.8717 9.99384C28.2033 9.60005 31.9994 13.0039 31.9994 17.3745V30.83C31.9994 31.4766 31.4752 32.0008 30.8286 32.0008H24.5846C23.938 32.0008 23.4138 31.4766 23.4138 30.83V19.903C23.4138 19.3855 23.2082 18.8891 22.8424 18.5232C22.4764 18.1573 21.9801 17.9517 21.4626 17.9517C20.9451 17.9517 20.4487 18.1573 20.0828 18.5232C19.7169 18.8891 19.5113 19.3855 19.5113 19.903V30.83C19.5113 31.4766 18.9871 32.0008 18.3406 32.0008H12.0965C11.45 32.0008 10.9258 31.4766 10.9258 30.83V10.537ZM13.2673 11.7077V29.6593H17.1698V19.903C17.1698 18.7646 17.622 17.6726 18.4272 16.8676C19.2322 16.0625 20.3241 15.6102 21.4626 15.6102C22.601 15.6102 23.6929 16.0625 24.498 16.8676C25.3031 17.6726 25.7553 18.7646 25.7553 19.903V29.6593H29.6579V17.3745C29.6579 14.4019 27.065 12.0547 24.0837 12.3257C23.0626 12.4185 22.0533 12.6725 21.1132 13.0755L18.8017 14.0661C18.44 14.2211 18.0246 14.1839 17.696 13.9674C17.3676 13.7508 17.1698 13.3835 17.1698 12.99V11.7077H13.2673Z",
    fill: "#0EC99E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4032bdb4dbaaecf6cdff7c800241c39d.svg";
export { ForwardRef as ReactComponent };